import { useBulkInviteStaffMutation } from '@/types/vue-apollo-helpers';

export function useBulkInviteStaff() {
  const { mutate: bulkInviteStaff, loading, error, onDone } = useBulkInviteStaffMutation();

  return {
    bulkInviteStaff,
    loading,
    error,
    onDone,
  };
}
